export const FETCH_LIVE = 'OFFER/FETCH_LIVE'
export const FETCH_STAGING = 'OFFER/FETCH_STAGING'
export const FETCH_ARCHIVED = 'OFFER/FETCH_ARCHIVED'
export const CLEAR = 'OFFER/CLEAR'
export const SET_CURRENT = 'OFFER/SET_CURRENT'
export const SET_DIRTY = 'OFFER/SET_DIRTY'
export const SET_REDIRECT = 'OFFER/REDIRECT'
export const SET_ALL_OFFERS = 'OFFER/ALL'



// WEBPACK FOOTER //
// ./src/store/modules/offers/mutations.js